var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("div", { staticClass: "title-block" }, [
              _c("h3", { staticClass: "title mt-4" }, [
                _c("span", {
                  staticClass: "sparkline bar",
                  attrs: { "data-type": "bar" },
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("apeironGwApp.reconsideracion.resultado")
                    ),
                  },
                }),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "card-body mb-3" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldset-9",
                                label: _vm.$t(
                                  "apeironGwApp.insaculacion.nombre"
                                ),
                                "label-for": "nombreAct",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "nombreAct", disabled: "" },
                                model: {
                                  value: _vm.solicitud.nombre,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.solicitud, "nombre", $$v)
                                  },
                                  expression: "solicitud.nombre",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldset-10",
                                label: _vm.$t("apeironGwApp.insaculacion.cvu"),
                                "label-for": "cvuAct",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "cvuAct", disabled: "" },
                                model: {
                                  value: _vm.solicitud.solicitante.cvu,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud.solicitante,
                                      "cvu",
                                      $$v
                                    )
                                  },
                                  expression: "solicitud.solicitante.cvu",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldset-11",
                                label: _vm.$t(
                                  "apeironGwApp.insaculacion.convocatoria"
                                ),
                                "label-for": "convocatoria",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "convocatoria", disabled: "" },
                                model: {
                                  value:
                                    _vm.solicitud.SOLICITUD_RIZOMA
                                      .solucionSolicitud.nombreConvocatoria,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.solicitud.SOLICITUD_RIZOMA
                                        .solucionSolicitud,
                                      "nombreConvocatoria",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "solicitud.SOLICITUD_RIZOMA.solucionSolicitud.nombreConvocatoria",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.verResultado
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "fieldset-4",
                                    label: _vm.$t(
                                      "apeironGwApp.resultadoBecas.calificacionPromedio"
                                    ),
                                    "label-for": "nombreComision",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "resultado",
                                      value: _vm.solicitud.calificacionPromedio,
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.verResultado && _vm.revisionRecons
                        ? _c(
                            "b-container",
                            [
                              _c(
                                "b-row",
                                _vm._l(
                                  _vm.revisionRecons,
                                  function (item, index) {
                                    return _c(
                                      "b-col",
                                      {
                                        key:
                                          "calificacion-" +
                                          item.revisor.revisorId,
                                        attrs: { sm: "4", md: "4", lg: "4" },
                                      },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "apeironGwApp.resultadoBecas.calificacion",
                                                { index: index + 1 }
                                              ),
                                              "label-for": "fechaInicio",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "fechaInicio",
                                                value:
                                                  item.respuesta.resultados
                                                    .calificacion,
                                                disabled: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }